<template>
    <div id="index" v-cloak>
      <!-- <Hezuo></Hezuo> -->
        <div class="visible-xs min_index">
            <header class="flex_center m_header">
                <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
                <h4 class="header_title">规则详情</h4>
            </header>
            <!-- 内容 -->
            <div class='rules_center'>
                <div class="rules_div">
                    <h5 class="rules_title">
                        会员详情
                    </h5>
                    <div class="rules_ul" v-html="ruleObj.content">
                        <div class="rules_li">
                            1.通过邀请码注册的用户将自动晋升为金牌会员
                        </div>
                        <div class="rules_li">
                            2.新用户普通会员及邀请码金牌会员等级的有效期未1年，
                            自获得之日计算；
                        </div>
                        <div class="img_ul flex_start flex_items">
                            <i><img src="@/assets/img/huangguan.png" alt=""></i>
                            <i><img src="@/assets/img/huangguanT.png" alt=""></i>
                        </div>
                    </div>
                </div>
                <div class="rules_div">
                    <h5 class="rules_title">
                        积分详情
                    </h5>
                    <div class="rules_ul" v-html="ruleObj.score">
                        <div class="rules_li">
                            1.通过每次直播签到可获得10积分
                        </div>
                        <div class="rules_li">
                            2.转发或分享专题文章视频可获得20积分
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";
import Hezuo from '@/components/tool/m_hezuo.vue'

    export default {
        name: "index",
        data() {
            return {
                user: {},//用户信息
                ruleObj: {},//规则详情
            };
        },
        computed: {},
        components: {
Hezuo
        },
        watch: {

        },
        methods: {
            goBackward() {//返回上一页
                this.$router.go(-1)
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();
                that.user = this.USER();
                that.getText();
            },
            getText() {//获取积分规则
                let that = this;
                this.$get('rule', {}).then(res => {
                    that.ruleObj = res.data;
                })
            },


        },
        mounted() {
            this.getUser();
            this.getShare();
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            }

        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
    }

    /* 内容 */
    .rules_center {
        padding: 1.5rem 0 0 1.5rem;
    }

    .rules_center .rules_div {
        margin-bottom: 2rem;
    }

    .rules_div .rules_title {
        padding: .4rem .4rem;
        border-bottom: .05rem solid #999999;
        font-size: 1.5rem;
        color: #333;
        margin-bottom: 1.6rem;
        font-weight: bold;
    }

    .rules_div .rules_li {
        margin-bottom: .8rem;
        font-size: 1.4rem;
        line-height: 1.6em;
        color: #666;
    }

    .rules_div .img_ul>i {
        width: 5rem;
        margin-left: 3rem;
        ;
    }
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_rules.vue